// extracted by mini-css-extract-plugin
export default {"container":"SearchPrediction_container__s4STa","item":"SearchPrediction_item__LhK78"};